import { type CSSProperties, useEffect } from "react";
import { enableTheme } from "./connections/atlassian/ap";

const releaseNotesUrl =
  "https://rixter.atlassian.net/wiki/spaces/RIFJ/pages/2891087873/iHub+on+Forge+release+notes?xpis=eyJicmlkZ2UiOiJzbWFydExpbmtzIiwiaWQiOiIxNzg4MTYzMjgyNzczIiwic291cmNlIjoiY29uZmx1ZW5jZSJ9";

const pageStyle: CSSProperties = {
  minHeight: "100vh",
  boxSizing: "border-box",
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "center",
  padding: "48px 24px",
  background: "var(--ds-surface, #ffffff)",
};

const bannerStyle: CSSProperties = {
  width: "100%",
  maxWidth: 1100,
  boxSizing: "border-box",
  padding: "32px",
  borderRadius: 6,
  border: "1px solid var(--ds-border-danger, #ff8f73)",
  background: "var(--ds-background-danger-bold, #de350b)",
  color: "var(--ds-text-inverse, #ffffff)",
  boxShadow: "0 8px 24px rgba(9, 30, 66, 0.18)",
};

const titleStyle: CSSProperties = {
  margin: "0 0 12px",
  fontSize: 34,
  lineHeight: 1.2,
  fontWeight: 700,
};

const messageStyle: CSSProperties = {
  margin: "0 0 14px",
  fontSize: 20,
  lineHeight: 1.45,
};

const linkStyle: CSSProperties = {
  color: "inherit",
  fontWeight: 700,
  textDecoration: "underline",
};

function App() {
  useEffect(() => {
    enableTheme();
  }, []);

  return (
    <main style={pageStyle}>
      <section
        aria-label="Integrations Hub update required"
        role="alert"
        style={bannerStyle}
      >
        <h1 style={titleStyle}>Integrations Hub update is required</h1>
        <p style={messageStyle}>
          Go to Marketplace apps and update the app.
        </p>
        <p style={messageStyle}>
          For release notes, see{" "}
          <a
            href={releaseNotesUrl}
            rel="noreferrer"
            style={linkStyle}
            target="_blank"
          >
            iHub on Forge release notes
          </a>
          .
        </p>
      </section>
    </main>
  );
}

export default App;
